import { io } from "socket.io-client";


const URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_BASE_URL ||
  `${window.location.protocol}//${window.location.host}`;


const socket = io(URL, {
  autoConnect: false,
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 30000,
  // Skip the polling transport entirely. Polling's handshake needs several
  // sequential HTTP requests to land on the same backend pod, which breaks
  // behind a load balancer without session affinity — a single WebSocket
  // connection stays pinned to one pod from the start, so it isn't exposed
  // to that problem.
  transports: ["websocket"]
});


export default socket;
